// customizeHubConfig.js — E7 (super-marathon) registry for the unified Customize hub.
//
// Pure data: the ordered sections the CustomizeHub offers, each pointing at an EXISTING
// view component (reused verbatim — no duplication). The hub is a launcher: it opens one
// section's own modal at a time, so the views keep their { open, onClose } contract and
// nothing is refactored. Adding a section = one entry here.

import { Palette, BookOpenCheck, Settings2, Package, PlugZap } from 'lucide-react';
import AppearanceView from './AppearanceView.jsx';
import AgentRulesView from './AgentRulesView.jsx';
import HooksView from './HooksView.jsx';
import PluginsView from './PluginsView.jsx';
import IntegrationsView from './IntegrationsView.jsx';

/**
 * @typedef {{ id: string, label: string, description: string, icon: any, component: any }} CustomizeTab
 * @type {CustomizeTab[]}
 */
export const CUSTOMIZE_TABS = [
  { id: 'appearance', label: 'Aparência', description: 'Tema, accent e densidade', icon: Palette, component: AppearanceView },
  { id: 'integrations', label: 'Integrações', description: 'Linear, Notion, Slack, Jira…', icon: PlugZap, component: IntegrationsView },
  { id: 'plugins', label: 'Plugins', description: 'Skills e pacotes instalados', icon: Package, component: PluginsView },
  { id: 'rules', label: 'Regras do Agente', description: '.apolorules / charter', icon: BookOpenCheck, component: AgentRulesView },
  { id: 'hooks', label: 'Hooks', description: 'Automações de ciclo de vida', icon: Settings2, component: HooksView },
];
